const SvgIconChevron = (props) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_3193_33213)">
      <path d="M7.41 8.59L12 13.17L16.59 8.59L18 10L12 16L6 10L7.41 8.59Z" />
    </g>
    <defs>
      <clipPath id="clip0_3193_33213">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgIconChevron;
